<template>
  <div class="multiroom">
    <el-row class="multiroom-container" :gutter="0">
      <multi-room-stat />
      <draggable @end="sortTab" v-bind="dragOptions">
        <mini-room v-for="room in orderedRoom" :key="room.name" :id="room.id" :room="room" />
      </draggable>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'
import { dateToTimeStamp } from '../../tools/timeTool'
import MiniRoom from './MiniRoom'
import MultiRoomStat from './MultiRoomStat.vue'

export default {
  name: 'MultiRooms',
  components: { MiniRoom, MultiRoomStat, draggable, },
  data() {
    return {
      popupStateService: false
    }
  },
  computed: {
    ...mapGetters({
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getAllInfos: 'infos/getAllInfos',
      getStyleEdition: 'newRooms/getStyleEdition',
      getAllCouverts: 'newRooms/getAllCouverts',
      getOccupationByServiceAndDay: 'newReservations/getOccupationByServiceAndDay',
      getRoomNbCouvertsLockedAllRooms: 'newRooms/getRoomNbCouvertsLockedAllRooms',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getSelectedDay: 'calendar/getSelectedDay',
      getAllServices: 'newServices/getAllServices',
      getCurrentServiceLockState: 'newServices/getCurrentServiceLockState',
      getCashDaysList: 'cash/getCashDaysList'
    }),
    orderedRoom: function () {
      return _.orderBy(this.getRoomsDatas, 'order')
    },
    dragOptions: function () {
      return {
        disabled: !this.getStyleEdition
      }
    },
    getPercentOccupation: function () {
      if (this.getAllCouvForAllRooms === 0) return '0'
      return Math.round((this.getOccupationByServiceAndDay(this.getSelectedDay, this.getSelectedMainService) / this.getAllCouvForAllRooms) * 100)
    },
    getAllCouvForAllRooms: function () {
      let nbLockedCouv = this.getRoomNbCouvertsLockedAllRooms({
        date: this.getSelectedDay,
        service: this.getSelectedMainService
      })
      return this.getAllCouverts(this.getSelectedDay, this.getSelectedMainService) - nbLockedCouv
    }
  },
  methods: {
    ...mapActions({
      updateRoomOrder: 'newRooms/updateRoomOrder',
      createLockedServices: 'newServices/createLockedServices',
      deleteLockedDays: 'newServices/deleteLockedDays'
    }),
    sortTab: function (evt) {
      Object.entries(evt.to.children).forEach(([order, room]) => {
        this.updateRoomOrder({ id: room.id, order: order })
      })
    },
    setStateService: function () {
      this.popupStateService = false
      // get switcher value
      let createLockedDay = !this.getCurrentServiceLockState
      let date = new Date(this.getSelectedDay.date)
      let ts = dateToTimeStamp(date.getDate(), date.getMonth(), date.getFullYear())
      // if create add locked day and service to db
      if (createLockedDay) {
        this.createLockedServices({
          days: [ts],
          service: this.getSelectedMainService
        }).then(() => { }).catch((err) => {
          console.error(err)
        })
      } else { // else delete it
        this.deleteLockedDays({
          tIds: [ts],
          service: this.getSelectedMainService
        }).then(() => { }).catch((err) => {
          console.error(err)
        })
      }
    },
    cashState: function (service) {
      if (this.getSelectedDay && this.getSelectedDay.date) {
        let date = new Date(this.getSelectedDay.date)
        let ts = dateToTimeStamp(date.getDate(), date.getMonth(), date.getFullYear())
        let cashList = this.getCashDaysList
        // get current service
        let serviceForDay = null
        if (this.getAllServices[service]) serviceForDay = this.getAllServices[service][this.getSelectedDay.labelDay]

        if (service && cashList && cashList[ts] && cashList[ts][service]) return cashList[ts][service]
        else if (serviceForDay && serviceForDay.cashOn) {
          return {
            type: serviceForDay.cashType,
            value: serviceForDay.cashPrice,
            isOnService: true
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.popup-discount-button {
  background-color: var(--color_red);
}

.popup-resa-detail-button {
  background-color: var(--color_green_table);
}

.popup-discount-button,
.popup-resa-detail-button {
  margin: 0 0 0 8px;
  color: white;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
}
</style>
